/* =====================================================================
   PB PRODUCT (v0.1) — variantskift uden serverkald (produktdata ligger på siden),
   pris/lager/knap/URL opdateres med det samme, galleri med swipe + miniaturer, antal-knapper.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, PB = window.PB;
  if (!PB) return;
  PB.ready(function () {
    var root = d.querySelector('[data-pb-product]'); if (!root) return;
    var data; try { data = JSON.parse(d.querySelector('[data-pb-product-json]').textContent); } catch (e) { return; }
    var form = root.querySelector('form.pb-buy__form'), input = root.querySelector('[data-pb-variant-input]');
    var btn = root.querySelector('[data-pb-buy-btn]'), label = root.querySelector('[data-pb-buy-label]');
    var track = root.querySelector('[data-pb-gallery-track]'), thumbs = root.querySelectorAll('[data-pb-thumb]');
    var pre = form && JSON.parse(form.getAttribute('data-pb-item') || '{}').pre;

    /* mobil: land præcis ved toppen af billedet (under den faste header), så titlen også kan ses —
       kun ved et almindeligt klik ind (ikke ved "tilbage", genindlæsning eller #-links) */
    (function () {
      if (!window.matchMedia('(max-width:749px)').matches || location.hash) return;
      var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (nav && nav.type !== 'navigate') return;
      var gal = root.querySelector('[data-pb-gallery]'); if (!gal) return;
      requestAnimationFrame(function () {
        if (window.scrollY > 10) return;
        var hh = parseInt(getComputedStyle(d.documentElement).getPropertyValue('--pb-header-h'), 10) || 0;
        var top = gal.getBoundingClientRect().top + window.scrollY - hh - 8;
        if (top > 0) window.scrollTo({ top: top, behavior: 'instant' });
      });
    })();

    /* varens egen adresse (samme sti som kunden kom ind på — også /en/... og /collections/.../products/...) */
var pageUrl = data.url || location.pathname;

function current() {
      var sel = [];
      root.querySelectorAll('[data-pb-opt]').forEach(function (fs) { var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null); });
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    function markAvailability() {
      var groups = root.querySelectorAll('[data-pb-opt]');
      groups.forEach(function (fs, gi) {
        fs.querySelectorAll('.pb-opt__val').forEach(function (lab) {
          var val = lab.querySelector('input').value;
          var sel = []; groups.forEach(function (g, i) { var c = g.querySelector('input:checked'); sel.push(i === gi ? val : (c ? c.value : null)); });
          var ok = data.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === sel[i]; }); });
          lab.classList.toggle('is-na', !ok);
        });
      });
    }
    function update() {
      var v = current(); markAvailability();
      if (!v) { if (btn) { btn.disabled = true; label.textContent = PB.t('unavailable'); } return; }
      input.value = v.id;
      form._pbVariant = { id: v.id, price: v.price, compare: v.compare_at_price || 0, variant_title: v.title, url: pageUrl + '?variant=' + v.id };
      var pr = root.querySelector('.pb-info__price .pb-price');
      if (pr) {
        var html = '<span class="pb-price__now' + (v.compare_at_price > v.price ? ' is-sale' : '') + '">' + PB.money(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<s class="pb-price__old">' + PB.money(v.compare_at_price) + '</s>';
        var extra = pr.querySelector('[data-pb-mpct]'), mb = extra && extra.querySelector('[data-pb-mprice]');
        var mpct = extra ? parseFloat(extra.getAttribute('data-pb-mpct')) || 0 : 0, mu = PB.mUnit(v.price, mpct);
        if (mb) { mb.textContent = PB.money(mu); extra.hidden = !(mu < v.price); } /* medlemsprisen rundet op til x,95 — skjult, hvis afrundingen æder rabatten */
        pr.innerHTML = html + (extra ? extra.outerHTML : '');
      }
      if (btn) { btn.disabled = !v.available; label.textContent = !v.available ? PB.t('sold_out') : (pre ? PB.t('preorder') : PB.t('add_to_cart')); }
      history.replaceState(history.state, '', pageUrl + '?variant=' + v.id);
      if (v.featured_media && track) {
        var slide = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      PB.emit('product:variant', v);
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-pb-opt]')) update(); });
    if (root.querySelector('[data-pb-opt]')) markAvailability();

    /* antal */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pb-qty] [data-step]'); if (!b) return;
      var q = b.parentElement.querySelector('input'), max = parseInt(q.max, 10) || 999;
      q.value = Math.min(max, Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10)));
    });

    /* lager ved prisen: skift linjen med varianten (linjen for hver variant ligger på elementet) */
var stk = root.querySelector('[data-pb-stock]'), stkMap = null;
try { stkMap = stk && stk.getAttribute('data-pb-stock-map') ? JSON.parse('{' + stk.getAttribute('data-pb-stock-map') + '}') : null; } catch (e) { stkMap = null; }
if (stkMap) PB.on('product:variant', function (v) { if (v && stkMap[v.id] != null) stk.innerHTML = stkMap[v.id]; });

/* mængderabat: kortene sætter antallet, så trinnet nås — varer fra samme mængderabat i kurven tæller med.
   Linjen nederst viser prisen for det valgte antal og hvor tæt kunden er på næste trin. */
var qd = root.querySelector('[data-pb-qd]');
if (qd) {
var qIn = root.querySelector('[data-pb-qty] input'), qKey = qd.getAttribute('data-k');
var qTiers = Array.prototype.slice.call(qd.querySelectorAll('.pb-qd__tier'));
var qSum = qd.querySelector('[data-pb-qd-sum]'), qCart = qd.querySelector('[data-pb-qd-cart]');
var qPrice = parseInt(qd.getAttribute('data-price'), 10) || 0;
var qName = qd.getAttribute('data-g') || '';
var qMem = parseFloat(qd.getAttribute('data-mem')) || 0, qComb = qd.getAttribute('data-comb') !== '0';
/* rabat pr. stk. (øre) ved trinnets procent p: medlemsprisen (rundet op til x,95) er grundprisen, og mængderabatten regnes
   af den (rundet op til x,95 — PB.mqUnit), når de lægges sammen — samme regel som kassen og kurven */
var qOff = function (price, p) {
var mu = qMem > 0 ? PB.mUnit(price, qMem) : price, cut = function (c) { return Math.floor(c * Math.round(p * 100) / 10000); };
var best = Math.max(price - mu, p > 0 ? cut(price) : 0);
if (p > 0 && mu < price && qComb) { var r = PB.mqUnit(mu, p); if (r < mu) best = Math.max(best, price - r); }
return best;
};
var qMore = qd.querySelector('[data-pb-qd-morebtn]');
if (qMore) qMore.addEventListener('click', function () {
qd.querySelectorAll('[data-pb-qd-hide]').forEach(function (li) { li.hidden = false; });
var first = qd.querySelector('[data-pb-qd-hide] a.pb-qd__nm'); qMore.remove(); if (first) first.focus();
});
var qPct = function (p) { var s = String(p); return PB.cfg.lang === 'en' ? s : s.replace('.', ','); };
var inCart = function () { return PB.qd && PB.cart ? PB.qd.groupQty(PB.cart.get(), qKey) : 0; };
var paintQd = function () {
var have = inCart(), sel = Math.max(1, parseInt(qIn && qIn.value, 10) || 1), tot = have + sel, on = qTiers[0], pct = 0, next = null;
qTiers.forEach(function (t) {
var q = +t.getAttribute('data-q');
if (q <= 1) return;
if (tot >= q) { on = t; pct = parseFloat(t.getAttribute('data-p')) || 0; } else if (!next) next = t;
});
qTiers.forEach(function (t) { var c = t === on; t.setAttribute('aria-checked', c ? 'true' : 'false'); t.tabIndex = c ? 0 : -1; });
/* én linje ad gangen, så intet rykker: er et trin nået, vises hvad kunden får (pris for det valgte antal + besparelse);
   under første trin vises tippet. Den længste udgave, der kan stå på én linje, bruges (fx uden gruppenavn på smal skærm). */
var opts = [], miss = next ? +next.getAttribute('data-q') - tot : 99;
if (pct > 0) {
var full = qPrice * sel, save = qOff(qPrice, pct) * sel; /* som kassen: pr. stk. */
var sumTxt = PB.esc(PB.t('qd_sum').replace('[n]', sel)).replace('[total]', '<b>' + PB.esc(PB.money(full - save)) + '</b>');
var saveTxt = '<em>' + PB.esc(PB.t('qd_save_amt').replace('[amount]', PB.money(save))) + '</em>';
opts.push(sumTxt + '<s>' + PB.esc(PB.money(full)) + '</s>' + saveTxt);
opts.push(sumTxt + saveTxt);
} else if (miss <= 3) {
var np = qPct(next.getAttribute('data-p'));
var nudge = function (k) { return '<i>' + PB.esc(PB.t(k).replace('[g]', qName).replace('[n]', miss).replace('[p]', np)) + '</i>'; };
if (qName) opts.push(nudge('qd_next_g'));
opts.push(nudge('qd_next'));
}
if (qSum) {
qSum.innerHTML = opts[0] || '';
for (var oi = 1; oi < opts.length && qSum.scrollWidth > qSum.clientWidth + 1; oi++) qSum.innerHTML = opts[oi];
}
if (qCart) { qCart.hidden = have <= 0; if (have > 0) qCart.textContent = PB.t('qd_in_cart').replace('[n]', have); }
};
var pickQd = function (t) {
if (!qIn) return;
var q = +t.getAttribute('data-q'), max = parseInt(qIn.max, 10) || 999;
qIn.value = Math.min(max, q <= 1 ? 1 : Math.max(1, q - inCart()));
paintQd();
};
qd.addEventListener('click', function (e) { var t = e.target.closest('.pb-qd__tier'); if (t) pickQd(t); });
qd.addEventListener('keydown', function (e) {
var t = e.target.closest('.pb-qd__tier'); if (!t) return;
var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
if (!d) return;
e.preventDefault();
var nt = qTiers[(qTiers.indexOf(t) + d + qTiers.length) % qTiers.length];
pickQd(nt); nt.focus();
});
if (qIn) { qIn.addEventListener('input', paintQd); qIn.addEventListener('change', paintQd); }
root.addEventListener('click', function (e) { if (e.target.closest('[data-pb-qty] [data-step]')) paintQd(); });
PB.on('cart:view', paintQd);
var qRz = 0;
window.addEventListener('resize', function () { cancelAnimationFrame(qRz); qRz = requestAnimationFrame(paintQd); }, { passive: true });
PB.on('product:variant', function (v) {
if (!v || !v.price) return;
qPrice = v.price;
qTiers.forEach(function (t) {
var q = +t.getAttribute('data-q'), p = parseFloat(t.getAttribute('data-p')) || 0;
var ea = t.querySelector('[data-pb-qd-each]'), sv = t.querySelector('[data-pb-qd-save]');
var us = qOff(v.price, p);
if (ea) ea.textContent = PB.t('qd_each').replace('[price]', PB.money(v.price - us));
if (sv) sv.textContent = PB.t('qd_save_amt').replace('[amount]', PB.money(us * q));
});
paintQd();
});
paintQd();
}

/* galleri: pile, prikker, tæller, miniaturer, piletaster, træk med musen, swipe — og et lille "nudge" der viser at der er flere billeder */
    var stage = root.querySelector('[data-pb-gallery-stage]');
    if (track && track.children.length > 1) {
      var slides = track.children, n = slides.length, cur = 0;
      var prevB = root.querySelector('[data-pb-gal-prev]'), nextB = root.querySelector('[data-pb-gal-next]');
      var count = root.querySelector('[data-pb-gal-count]'), dots = root.querySelectorAll('[data-pb-gal-dot]'), hint = root.querySelector('[data-pb-gal-hint]');
      var used = false;
      function hideHint() { if (used) return; used = true; if (hint) hint.classList.add('is-gone'); }
      var target = null, endT = null, raf = 0;
      function go(i) { i = Math.max(0, Math.min(n - 1, i)); target = i; mark(i); track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
      function keepInView(t) {
        var box = t.parentElement;
        if (box.scrollHeight > box.clientHeight + 2) { if (t.offsetTop < box.scrollTop) box.scrollTo({ top: t.offsetTop - 6, behavior: 'smooth' }); else if (t.offsetTop + t.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTo({ top: t.offsetTop + t.offsetHeight - box.clientHeight + 6, behavior: 'smooth' }); }
        if (box.scrollWidth > box.clientWidth + 2) { if (t.offsetLeft < box.scrollLeft) box.scrollTo({ left: t.offsetLeft - 6, behavior: 'smooth' }); else if (t.offsetLeft + t.offsetWidth > box.scrollLeft + box.clientWidth) box.scrollTo({ left: t.offsetLeft + t.offsetWidth - box.clientWidth + 6, behavior: 'smooth' }); }
      }
      function mark(i) {
        if (i === cur && count && count.textContent.indexOf((i + 1) + ' /') === 0) return;
        cur = i;
        if (count) count.textContent = (i + 1) + ' / ' + n;
        if (prevB) prevB.disabled = i <= 0;
        if (nextB) nextB.disabled = i >= n - 1;
        dots.forEach(function (dt, j) { dt.classList.toggle('is-on', j === i); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); if (j === i) keepInView(t); });
      }
      if (prevB) prevB.addEventListener('click', function () { hideHint(); go(cur - 1); });
      if (nextB) nextB.addEventListener('click', function () { hideHint(); go(cur + 1); });
      dots.forEach(function (dt) { dt.addEventListener('click', function () { hideHint(); go(parseInt(dt.getAttribute('data-pb-gal-dot'), 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { hideHint(); go(parseInt(t.getAttribute('data-pb-thumb'), 10)); }); });
      track.addEventListener('scroll', function () {
        /* swipe/træk: fremhævningen flytter sig live; klik/pile: den er allerede sat, så den hopper ikke via mellemliggende billeder */
        if (target === null && !raf) raf = requestAnimationFrame(function () { raf = 0; mark(Math.round(track.scrollLeft / track.clientWidth)); });
        clearTimeout(endT); endT = setTimeout(function () { target = null; mark(Math.round(track.scrollLeft / track.clientWidth)); }, 140);
      }, { passive: true });
      if (stage) stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); hideHint(); go(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); hideHint(); go(cur - 1); }
      });
      track.addEventListener('touchstart', hideHint, { passive: true });
      var drag = null, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; drag = { x: e.clientX, sl: track.scrollLeft, i: cur, id: e.pointerId }; moved = false; });
      track.addEventListener('pointermove', function (e) { if (!drag || e.pointerId !== drag.id) return; var dx = e.clientX - drag.x; drag.dx = dx; if (!moved) { if (Math.abs(dx) < 6) return; moved = true; track.classList.add('is-drag'); try { track.setPointerCapture(e.pointerId); } catch (x) {} } track.scrollLeft = drag.sl - dx; });
      /* snap forbliver slået fra til glidet er færdigt — ellers trækker browserens snap først billedet tilbage */
      function release() { var done = false, fin = function () { if (done) return; done = true; track.classList.remove('is-drag'); track.removeEventListener('scrollend', fin); }; track.addEventListener('scrollend', fin); setTimeout(fin, 700); }
      function end() { if (!drag) return; var s = drag; drag = null; if (!moved) return; hideHint(); var dx = -(s.dx || 0); go(dx > 40 ? s.i + 1 : dx < -40 ? s.i - 1 : s.i); release(); setTimeout(function () { moved = false; }, 0); }
      track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end); track.addEventListener('lostpointercapture', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches, seen = false;
      try { seen = sessionStorage.getItem('pbGalNudge') === '1'; } catch (x) {}
      if (!reduce && !seen && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return; io.disconnect();
          setTimeout(function () {
            if (used || cur !== 0) return;
            track.style.scrollSnapType = 'none';
            track.scrollTo({ left: Math.min(70, track.clientWidth * 0.14), behavior: 'smooth' });
            setTimeout(function () { track.scrollTo({ left: 0, behavior: 'smooth' }); setTimeout(function () { track.style.scrollSnapType = ''; }, 450); }, 520);
            try { sessionStorage.setItem('pbGalNudge', '1'); } catch (x) {}
          }, 900);
        }, { threshold: 0.6 });
        io.observe(track);
      }
      setTimeout(hideHint, 6000);
    }
  });
})();

/* BESKRIVELSE: klippes ud for bunden af billedrammen (computer) eller efter ~7 linjer (mobil) — "Læs mere" folder ud, "Vis mindre" sammen */
(function () {
  'use strict';
  function init() {
    var d = document.querySelector('.pb-info__desc'); if (!d || d.__pbMore) return; d.__pbMore = 1;
    var T = (window.PB_CFG && PB_CFG.t) || {}, stage = document.querySelector('.pb-gallery__stage'), gal = document.querySelector('.pb-gallery'), open = false;
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pb-desc-more'; btn.hidden = true; d.parentNode.insertBefore(btn, d.nextSibling);
    function fit() {
      if (open) return;
      d.style.maxHeight = ''; d.classList.remove('is-clamped');
      var full = d.scrollHeight, h = 180, side = stage && gal && gal.getBoundingClientRect().right <= d.getBoundingClientRect().left + 1;
      if (side) { var info = d.parentNode.getBoundingClientRect(), g = gal.getBoundingClientRect(), s = stage.getBoundingClientRect(); h = Math.max(120, Math.round((s.bottom - g.top) - (d.getBoundingClientRect().top - info.top))); }
      if (full <= h + 40) { btn.hidden = true; return; }
      d.style.maxHeight = h + 'px'; d.classList.add('is-clamped'); btn.hidden = false; btn.classList.remove('is-open'); btn.textContent = T.read_more || 'Læs mere';
    }
    btn.addEventListener('click', function () {
      open = !open;
      if (open) { d.style.maxHeight = ''; d.classList.remove('is-clamped'); btn.classList.add('is-open'); btn.textContent = T.read_less || 'Vis mindre'; }
      else { fit(); var y = d.getBoundingClientRect().top + window.scrollY - 120; if (window.scrollY > y) window.scrollTo({ top: y, behavior: 'smooth' }); }
    });
    var t0; window.addEventListener('resize', function () { clearTimeout(t0); t0 = setTimeout(fit, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* UNDER VAREN: "Dette kunne være interessant" (Shopifys anbefalinger) + "Senest set" (gemt i browseren, højst 12) · TILBAGE til siden, man kom fra */
(function () {
  'use strict';
  function rows() { if (window.PB && PB.rows) PB.rows.scan(); }
  function init() {
    var rc = document.querySelector('[data-pb-recs]');
    if (rc) fetch(rc.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (h) { var t = document.createElement('div'); t.innerHTML = h; var sec = t.querySelector('.pb-recs'); if (sec) { rc.parentNode.replaceChild(sec, rc); rows(); } else rc.parentNode.removeChild(rc); }).catch(function () {});
    var rs = document.querySelector('[data-pb-recent]'), KEY = 'pb_recent', list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) {}
    var cur = rs && rs.getAttribute('data-h');
    if (cur) { try { localStorage.setItem(KEY, JSON.stringify([cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 12))); } catch (e) {} }
    if (rs) {
      var show = list.filter(function (h) { return h !== cur; }).slice(0, 8), root = rs.getAttribute('data-root') || '/';
      if (root.slice(-1) !== '/') root += '/';
      if (show.length) Promise.all(show.map(function (h) { return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=pb-card-only').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }); })).then(function (parts) {
        var ul = rs.querySelector('[data-pb-row-track]'), n = 0;
        parts.forEach(function (p) { if (!p) return; var t = document.createElement('div'); t.innerHTML = p; var li = t.querySelector('li'); if (li) { ul.appendChild(li); n++; } });
        if (n) { var tally = {}, best = null, bn = 0; [].forEach.call(ul.querySelectorAll('.pb-card'), function (c) { var v = c.style.getPropertyValue('--lc1').trim(); if (!v) return; tally[v] = (tally[v] || 0) + 1; if (tally[v] > bn) { bn = tally[v]; best = c; } }); if (best) for (var i = 0; i < best.style.length; i++) { var pr = best.style[i]; if (pr.indexOf('--lc') === 0) rs.style.setProperty(pr, best.style.getPropertyValue(pr)); }   /* farven følger det spil, der fylder mest (som Nyheder) */ rs.hidden = false; rs.setAttribute('data-pb-row', ''); rows(); }
      });
    }
    var bk = document.querySelector('[data-pb-back]');
    if (bk) {
      var a = bk.querySelector('a'), s = null, T = (window.PB_CFG && PB_CFG.t) || {};
      try { s = JSON.parse(sessionStorage.getItem('pbBack') || 'null'); } catch (e) {}
      if (s && s.u && s.t && Date.now() - s.at < 6 * 3600e3) {
        a.href = s.u; a.querySelector('span').textContent = (T.back_to || 'Tilbage til [t]').replace('[t]', s.t); bk.hidden = false;
        a.addEventListener('click', function (e) { if (document.referrer === s.u && history.length > 1) { e.preventDefault(); history.back(); } });   /* samme side som før → bevarer filtre og hvor man var nået til */
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---------- billeder i fuld størrelse (lightbox) ----------
   Let: intet bibliotek, intet bygges før første klik. Tre celler (forrige · aktuelle · næste) i en stribe, der følger fingeren,
   så nabobilledet glider ind, mens man trækker. Efter et skift flyttes cellerne rundt i stedet for at skifte billeder (intet blink).
   Aktuelle billede: den allerede indlæste version straks, den skarpe (2000 px) når den er hentet. Naboerne bruger den indlæste størrelse.
   Klik/tryk på billedet = zoom (højst 4x). Swipe ned lukker (baggrund + blur toner ud). Pile/piletaster på computer. ESC/klik udenfor lukker.
   Animationer slås fra ved "reducer bevægelse". */
(function () {
  var d = document, w = window, box, bgl, stage, trk, cells, cnt, list = [], at = 0, zoom = false, back = null, track = null;
  var sx = 0, sy = 0, t0 = 0, dx = 0, dy = 0, axis = '', busy = false;
  var calm = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var L = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var R = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
  function t(k, f) { var v = w.PB && PB.t ? PB.t(k) : k; return !v || v === k ? f : v; }
  function big(u) { try { var x = new URL(u, location.href); x.searchParams.set('width', '2000'); return x.toString(); } catch (e) { return u; } }
  function mod(i) { return (i % list.length + list.length) % list.length; }
  function cur() { return cells[1]; }
  function pic(c) { return c.firstChild; }
  function W() { return stage.clientWidth || w.innerWidth; }
  function setTrack(x, e) { trk.style.transition = e ? 'transform ' + e : 'none'; trk.style.transform = x == null ? '' : 'translate3d(' + x + 'px,0,0)'; }
  function lift(y, s, e) { var im = pic(cur()); im.style.transition = e ? 'transform ' + e : 'none'; im.style.transform = y == null ? '' : 'translate3d(0,' + y + 'px,0) scale(' + s + ')'; }
  function fade(o, e) { bgl.style.transition = e ? 'opacity ' + e : 'none'; bgl.style.opacity = o == null ? '' : o; }
  function set(c, i) {
    var im = pic(c);
    if (i == null) { im.removeAttribute('src'); im.alt = ''; c.removeAttribute('data-i'); return; }
    var it = list[i], s = im.getAttribute('src'); c.setAttribute('data-i', i); im.alt = it.alt;
    if (s !== it.lo && s !== it.hi) im.src = it.lo;
  }
  function sharpen() {
    var c = cur(), i = +c.getAttribute('data-i'), it = list[i]; if (!it) return;
    var hi = new Image(); hi.onload = function () { if (cells[1] === c && +c.getAttribute('data-i') === i && !box.hidden && !zoom) pic(c).src = it.hi; }; hi.src = it.hi;
  }
  function mark() {
    cells.forEach(function (c, k) { c.classList.toggle('is-cur', k === 1); });
    cnt.textContent = list.length > 1 ? (at + 1) + ' / ' + list.length : '';
    box.classList.toggle('is-many', list.length > 1); box.setAttribute('aria-label', list[at].alt || d.title);
  }
  function fill() { set(cells[0], list.length > 1 ? mod(at - 1) : null); set(cells[1], at); set(cells[2], list.length > 1 ? mod(at + 1) : null); mark(); sharpen(); }
  function clean() { cells.forEach(function (c) { var im = pic(c); im.style.transform = ''; im.style.transition = ''; im.style.width = ''; }); setTrack(null); trk.style.transition = ''; fade(null); bgl.style.transition = ''; }
  function build() {
    var cell = '<div class="pb-lb__cell"><img class="pb-lb__img" alt="" decoding="async" draggable="false"></div>';
    box = d.createElement('div'); box.className = 'pb-lb'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<div class="pb-lb__bg"></div><div class="pb-lb__stage"><div class="pb-lb__track">' + cell + cell + cell + '</div></div><p class="pb-lb__count" aria-live="polite"></p>' +
      '<button type="button" class="pb-lb__btn pb-lb__close" data-lb="close" aria-label="' + PB.esc(t('lb_close', 'Close')) + '">' + X + '</button>' +
      '<button type="button" class="pb-lb__btn pb-lb__prev" data-lb="prev" aria-label="' + PB.esc(t('lb_prev', 'Previous')) + '">' + L + '</button>' +
      '<button type="button" class="pb-lb__btn pb-lb__next" data-lb="next" aria-label="' + PB.esc(t('lb_next', 'Next')) + '">' + R + '</button>';
    d.body.appendChild(box);
    bgl = box.querySelector('.pb-lb__bg'); stage = box.querySelector('.pb-lb__stage'); trk = box.querySelector('.pb-lb__track'); cnt = box.querySelector('.pb-lb__count');
    cells = [].slice.call(trk.children);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lb]');
      if (b) { var a = b.getAttribute('data-lb'); if (a === 'close') close(); else slide(a === 'next' ? 1 : -1); return; }
      if (busy) return;
      if (e.target === pic(cur())) {
        if (zoom) { setZoom(false); return; }
        var v = vis(); if (e.clientX < v.l || e.clientX > v.l + v.w || e.clientY < v.t || e.clientY > v.t + v.h) { close(); return; }
        setZoom(true, e); return;
      }
      if (!zoom) close();
    });
    /* fingeren: striben følger med (vandret) eller billedet trækkes ned (lodret); retningen låses efter 8 px */
    box.addEventListener('touchstart', function (e) {
      if (zoom || busy || e.touches.length > 1) { axis = 'no'; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; t0 = Date.now(); dx = dy = 0; axis = '';
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      if (zoom || busy || axis === 'no') return;
      if (e.touches.length > 1) { axis = 'no'; setTrack(-W(), '.2s ease-out'); lift(0, 1, '.2s ease-out'); fade(1, '.2s'); return; }
      dx = e.touches[0].clientX - sx; dy = e.touches[0].clientY - sy;
      if (!axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (axis === 'x') setTrack(-W() + (list.length > 1 ? dx : dx / 3));
      else if (axis === 'y') { var y = Math.max(0, dy); lift(y, 1 - Math.min(y / 1200, 0.12)); fade(1 - Math.min(y / 450, 0.7)); }
    }, { passive: true });
    box.addEventListener('touchend', function () {
      var a = axis, ms = Math.max(1, Date.now() - t0); axis = '';
      if (zoom || busy || !a || a === 'no') return;
      if (a === 'x') {
        if (list.length > 1 && (Math.abs(dx) > 60 || Math.abs(dx) / ms > 0.45)) slide(dx < 0 ? 1 : -1);
        else { setTrack(-W(), '.22s ease-out'); setTimeout(function () { if (!busy && !axis) setTrack(null); }, 240); }
      } else if (dy > 110 || (dy > 30 && dy / ms > 0.5)) {
        if (calm) { close(); return; }
        busy = true; lift(Math.round(w.innerHeight * 0.5), 0.9, '.2s ease-in'); fade(0, '.2s'); setTimeout(close, 200);
      } else { lift(0, 1, '.22s ease-out'); fade(1, '.22s'); setTimeout(function () { if (!busy && !axis) { lift(null); fade(null); } }, 240); }
    });
    d.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') slide(1); else if (e.key === 'ArrowLeft') slide(-1);
      else if (e.key === 'Tab') { var f = [].slice.call(box.querySelectorAll('button')).filter(function (x) { return x.offsetParent; }), i = f.indexOf(d.activeElement);
        if (e.shiftKey ? i <= 0 : i === f.length - 1) { e.preventDefault(); f[e.shiftKey ? f.length - 1 : 0].focus(); } }
    });
  }
  /* den synlige del af det aktuelle billede (billedet fylder cellen med object-fit: contain) */
  function vis() { var im = pic(cur()), r = im.getBoundingClientRect(), nw = im.naturalWidth || r.width, nh = im.naturalHeight || r.height, vw = Math.min(r.width, r.height * nw / nh), vh = vw * nh / nw; return { l: r.left + (r.width - vw) / 2, t: r.top + (r.height - vh) / 2, w: vw, h: vh }; }
  function setZoom(on, e) {
    var c = cur(), im = pic(c), v = vis();
    zoom = on; im.style.width = on ? Math.max(v.w * 2, Math.min(im.naturalWidth || 0, v.w * 4)) + 'px' : ''; box.classList.toggle('is-zoom', on);
    if (!on || !e) return;
    var fx = Math.min(1, Math.max(0, (e.clientX - v.l) / v.w)), fy = Math.min(1, Math.max(0, (e.clientY - v.t) / v.h));
    requestAnimationFrame(function () { c.scrollLeft = fx * im.offsetWidth - c.clientWidth / 2; c.scrollTop = fy * im.offsetHeight - c.clientHeight / 2; });
  }
  /* glidende skift: striben glider én celle, derefter flyttes cellerne rundt (intet billedskift = intet blink) */
  function slide(dir) {
    if (busy || list.length < 2) return;
    if (zoom) setZoom(false);
    if (calm) { at = mod(at + dir); fill(); return; }
    busy = true; setTrack(-W() - dir * W(), '.3s cubic-bezier(.2,.8,.2,1)');
    setTimeout(function () {
      at = mod(at + dir);
      if (dir > 0) { trk.appendChild(cells[0]); cells.push(cells.shift()); } else { trk.insertBefore(cells[2], cells[0]); cells.unshift(cells.pop()); }
      setTrack(null); trk.style.transition = '';
      set(dir > 0 ? cells[2] : cells[0], mod(at + dir));
      mark(); sharpen(); busy = false;
    }, 310);
  }
  function open(items, i, from) {
    if (!box) build();
    list = items; at = i; back = from; busy = false; axis = ''; zoom = false; box.classList.remove('is-zoom'); clean(); fill();
    box.hidden = false;
    if (w.PB && PB.lock) PB.lock(true);
    box.querySelector('[data-lb="close"]').focus({ preventScroll: true });
  }
  function close() {
    if (!box || box.hidden) return;
    box.hidden = true; zoom = false; box.classList.remove('is-zoom'); busy = false; axis = ''; clean();
    cells.forEach(function (c) { set(c, null); });
    if (w.PB && PB.lock) PB.lock(false);
    if (track && track.children[at]) track.scrollTo({ left: track.children[at].offsetLeft });
    if (back) back.focus({ preventScroll: true });
  }
  function items(tr) { return [].map.call(tr.querySelectorAll('.pb-gallery__slide img'), function (x) { var s = x.currentSrc || x.src; return { lo: s, hi: big(s), alt: x.alt || '' }; }); }
  d.addEventListener('click', function (e) {
    var im = e.target.closest && e.target.closest('[data-pb-gallery-track] .pb-gallery__slide img'); if (!im) return;
    track = im.closest('[data-pb-gallery-track]');
    open(items(track), Math.max(0, [].indexOf.call(track.children, im.closest('.pb-gallery__slide'))), im.closest('[data-pb-gallery-stage]'));
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-pb-gallery-stage]')) return;
    track = e.target.querySelector('[data-pb-gallery-track]'); if (!track || !track.children.length) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    open(items(track), Math.min(track.children.length - 1, Math.max(0, i)), e.target);
  });
})();
